/**
 * Coid 2.0 server
 * Coid 2.0 server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OperationType {
    C2C2 = 'C2C2',
    C2CR = 'C2CR',
    C2CR_RTP = 'C2CR_RTP',
    M2M = 'M2M',
    C2B2 = 'C2B2',
    C2B2_RTP = 'C2B2_RTP',
    C2B2E = 'C2B2E',
    C2B2_V2 = 'C2B2_V2',
    C2BR = 'C2BR',
    C2BRE = 'C2BRE',
    C2BR_V2 = 'C2BR_V2',
    C2BRM_V2 = 'C2BRM_V2',
    B2C2I = 'B2C2I',
    B2C2U = 'B2C2U',
    CHBK = 'CHBK',
    ADJT = 'ADJT'
}

